import { Model, go } from 'oderon-vue'
// import { delay } from 'oderon-commons/src/utils'
// import _ from 'lodash'

export const Keyboard = new Model('/keyboards')
Keyboard.patch = (id, body) => go.patch(`/keyboards/${id}`, body)
Keyboard.findHistory = (id, ps) => go.get(`/keyboards/${id}/history`, ps)

// O primeiro find verifica se o id do histórico corresponde
// ao da câmera (usado para garantia ao abrir/editar registro).
// O segundo só abre o registro pelo id (usado no histórico
// global).
Keyboard.findHistoryById = (historyId, keyboardId) => {
  if (keyboardId != null) {
    return go.get(`/keyboards/${keyboardId}/history/${historyId}`)
  } else {
    return go.get(`/keyboards/history/${historyId}`)
  }
}

Keyboard.saveHistory = (body) => {
  if (body.id)
    return go.put(`/keyboards/${body.keyboardId}/history/${body.id}`, body)
  else return go.post(`/keyboards/${body.keyboardId}/history`, body)
}
